module.exports = __webpack_public_path__ + "static/media/buckinghamshire_bs.df415f08.png";